import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Outlet,
} from "react-router-dom";                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
import CreateAccount from "./CreateAccount";
import SignIn from "./SignIn";
import ForgotPassword from "./ForgotPassword";
import Otp from "./Otp";
import ChangePassword from "./ChangePassword";
import SideBar from "./SideBar";
import AddDoctor from "./AddDoctor";
import Registration from "./Registration";
import Dashboard from "./Dashboard";
import ClinicDashboard from "./ClinicDashboard";
import Company from "./Company";
import Modules from "./Modules";
import AddModules from "./AddModules";
import SubModules from "./SubModules";
import AssignModules from "./AssignModules";
import AddSubModules from "./AddSubModules";
import AllClinics from "./AllClinics";
import Clinics from "./Clinics";
import Subscriptions from "./Subscriptions";
import Reports from "./Reports";
import SupportTickets from "./SupportTickets";
import UserManagement from "./UserManagement";
import AddPatient from "./AddPatient";
import ClinicSidebar from "./ClinicSidebar";
import ClinicPatients from "./ClinicPatients";
import PatientList from "./PatientList";
import Doctors from "./Doctors";
import AddPatientReports from "./AddPatientReports";
import Departments from "./Departments";
import DepartmentDetails from "./DepartmentDetails";
import PatientReports from "./PatientReports";
import ViewReports from "./ClinicComponent/ViewReports";
import DoctorSidebar from "./DoctorSidebar";
import DoctorProfile from "./DoctorProfile";
import DoctorDashBoard from "./DoctorDashBoard";
import PatientSidebar from "./PatientSidebar";
import PatientProfile from "./PatientProfile";
import PatientAppointments from "./PatientAppointments";
import UpcomingAppointments from "./UpcomingAppointments";
import AppointmentHistory from "./AppointmentHistory";
import PatientHistory from "./PatientHistory";
import TodaysAppointments from "./TodaysAppointments";
import DrPatientsList from "./DrPatientsList";
import Invoice from "./Invoice";
import ClinicAppointments from "./ClinicAppointments";
import AddAppointment from "./AddAppointment";
import PatientLabReports from "./PatientLabReports";
import ViewPatientLabReports from "./ViewPatientLabReports";
import PatientRecord from "./PatientRecord";
import OTBookings from "./OTBookings";
import Prescription from "./Prescription";
import LabReportsHistory from "./LabReportsHistory";
import PatientPrescription from "./PatientPrescription";
import DoctorView from "./DoctorView";
import Treatments from "./Treatments";
import TreatmentPlans from "./TreatmentPlans";
import ClinicPatientView from "./ClinicPatientView";
import DoctorPatientView from "./DoctorPatientView";
import AddPrescription from "./AddPrescription";
import ClinicUsers from "./ClinicUsers";
import ClinicRegistration from "./ClinicRegistration";
import ProtectRoutes from "./ProtectRoutes";
import DoctorsAdd from "./DoctorsAdd";
import PatientsAdd from "./PatientsAdd";
import DoctorsTable from "./DoctorsTable";
import PatientDetails from "./PatientDetails";
import DoctorAppointments from "./DoctorComponent.jsx/Appointments/DoctorAppointments";
import AllAppointments from "./ClinicComponent/AllAppointments";
import ClinicBilling from "./ClinicBilling";
import ClinicPrescription from "./ClinicPrescription";
import ClinicPrescriptionForm from "./ClinicPrescriptionForm";
import CreateInvoice from "./CreateInvoice";
import OpCaseSheet from "./OpCaseSheet";
import ClinicProfile from "./ClinicProfile";
import AppointmentDetails from "./DoctorComponent.jsx/Appointments/AppointmentDetails";
import PrescriptionDetails from "./PrescriptionDetails";
import DoctorPrescriptionDetails from "./DoctorComponent.jsx/DrPrescriptionDetails";
import PatientOverview from "./ClinicComponent/PatientOverview";
import PatientRescheduled from "./DoctorComponent.jsx/PatientRescheduled";
import DoctorsideProfile from "./DoctorsideProfile";
import RescheduleAppointment from "./RescheduleAppointment"; 
import DoctorPrescriptionView from "./DoctorPrescriptionView";
import PatientsOverview from "./DoctorComponent.jsx/Appointments/PatientsOverview";
import ClinicPrescriptionView from "./ClinicPrescriptionView";
import DrPatientReports from "./DoctorComponent.jsx/DrPatientReports";
import LabReport from "./DoctorComponent.jsx/LabReport";
import DrPrescriptionDetails from "./DoctorComponent.jsx/DrPrescriptionDetails";
import OutPatientOverview from "./ClinicComponent/OutPatientOverview";
import DoctorInfoCard from "./DoctorInfoCard";
import AddDepartmentForm from "./AddDepartmentForm";
import ClinicsideAppointmentDetails from "./DoctorComponent.jsx/Appointments/ClinicsideAppointmentDetails";
import InvoiceView from "./InvoiceView";
import EditPatientReport from "./EditPatientReport";
import ClinicPharmacy from "./pharmacy/ClinicPharmacy";
import AddPharmacy from "./pharmacy/AddPharmacy";
import AddSettings from "./pharmacy/AddSettings";
import PharmacyView from "./pharmacy/PharmacyView";
import StaffMain from "./staffmanagement/StaffMain";
import StaffStepper from "./staffmanagement/staffdetailsform/StaffStepper";
import StaffView from "./staffmanagement/StaffView";
import StaffAttendence from "./staffmanagement/StaffAttendence";
import PharmacySidebar from "./pharmacy/PharmacySidebar";
import PharmaDashboard from "./pharmacy/PharmaDashboard";
import MedicineInventory from "./pharmacy/MedicineInventory";
import PrescriptionIntegration from "./pharmacy/PrescriptionIntegration";
import PharmaBilling from "./pharmacy/PharmaBilling";
import ProcurementSupplier from "./pharmacy/ProcurementSupplier";
import ComplianceSecurity from "./pharmacy/ComplianceSecurity";
import ReportsAnalytics from "./pharmacy/ReportsAnalytics";
import MultiBranchPharmacy from "./pharmacy/MultiBranchPharmacy";
import PharmacyMedicine from "./pharmacy/PharmacyMedicine";
import ProtectedLayout from "./ProtectedLayout";
import AddBillingForm from "./pharmacy/AddBillingForm";
import SupportHandling from "./Administration/SupportHandling";
import ClinicAnalytics from "./ClinicAnalytics";
import Procurement from "./pharmacy/Procurement";
import ProcurementTabs from "./pharmacy/ProcurementTabs";
import PharmacyintegrationDetails from "./pharmacy/PharmacyintegrationDetails";
import PharmaAnalytics from "./pharmacy/PharmaAnalytics";
import AddBranchPharmacy from "./pharmacy/AddBranchPharmacy";
import BranchView from "./pharmacy/BranchView";
import CompSecuAddemp from "./pharmacy/CompSecuAddemp";
import BedAllotement from "./wardmanagement/BedAllotement";
import PatientAdmission from "./wardmanagement/PatientAdmission";
import MonitorTracking from "./wardmanagement/MonitorTracking";
import MonitorPatientDetails from "./wardmanagement/MonitorPatientDetails";
import PatientCareDetailedView from "./wardmanagement/PatientCareDetailedView";
import WardPharmacy from "./wardmanagement/WardPharmacy";
import AddAdmission from "./wardmanagement/AddAdmission";
import AddWardPharmacy from "./wardmanagement/AddWardPharmacy";
import PharmacyDashboard from "./pharmacy/PharmacyDashboard";
import PharmacyInvoice from "./pharmacy/PharmacyInvoice";
import PharmacyCustomerorders from "./pharmacy/PharmacyCustomerorders";
import PharmacyOrderdashboard from "./pharmacy/PharmacyOrderdashboard";
import PharmacyBrandDetails from "./pharmacy/PharmacyBrandDetails";
import PharmacyCategoryDetails from "./pharmacy/PharmacyCategoryDetails";
import PharmacyOrderDetails from "./pharmacy/PharmacyOrderDetails";
import PharmacyExpenses from "./pharmacy/PharmacyExpenses";
import PharmacyPescription from "./pharmacy/PharmacyPescription";
import PharmacyMultibranches from "./pharmacy/PharmacyMultibranches";
import PharmacyDistribution from "./pharmacy/PharmacyDistribution";
import PharmacyPurchase1 from "./pharmacy/PharmacyPurchase1";
import PharmacySales from "./pharmacy/PharmacySales";
import PharmacyStock from "./pharmacy/PharmacyStock";
import SupplierMaster from "./pharmacy/SupplierMaster";
import PurchaseOrder from "./pharmacy/PurchaseOrder";
import PharmacyPurchasereturn from "./pharmacy/PharmacyPurchasereturn";
import AddPaymentForm from "./pharmacy/AddPaymentForm";
import SalesReturn from "./pharmacy/SalesReturn";
import AddInvoiceForm from "./pharmacy/AddInvoiceForm";
import CartPage from "./pharmacy/CartPage";
import PatientFollowUp from "./pharmacy/PatientFollowUp";import PharmacyOrders from "./pharmacy/PharmacyOrders";
import SaleReturns from "./pharmacy/SaleReturns";
import AddSaleReturn from "./pharmacy/AddSaleReturn";

import AddDistributor from "./pharmacy/AddDistributor";
import SelectDistrubutorModal from "./pharmacy/SelectDistributorModal"
import CareTrackingScreen from "./wardmanagement/CareTrackingScreen";
import CareTrackingForm from "./wardmanagement/CareTrackingForm";
import OrderInvoice from "./pharmacy/OrderInvoice";
import PatientSaleHistory from "./pharmacy/PatientSaleHistory";
import StockComponentScreen from "./pharmacy/StockComponentScreen";
const routes = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route index element={<SignIn />} />
      <Route path="Create-Account/?" element={<CreateAccount />} />
      <Route path="SignIn" element={<SignIn />} />
      <Route path="ForgotPassword" element={<ForgotPassword />} />
      <Route path="Otp" element={<Otp />} />
      <Route path="ChangePassword" element={<ChangePassword />} />

      <Route element={<ProtectRoutes />}>

       <Route element={<SideBar />}>
          <Route path="Dashboard" element={<Dashboard />} />
          <Route path="Company" element={<Company />} />
          <Route path="Modules" element={<Modules />} />
          <Route path="AddModules" element={<AddModules />} />
          <Route path="SubModules" element={<SubModules />} />
          <Route path="AssignModules" element={<AssignModules />} />
          <Route path="AddSubModules" element={<AddSubModules />} />
          <Route path="AllClinics" element={<AllClinics />} />
          <Route path="Clinics" element={<Clinics />} />
          <Route path="Subscriptions" element={<Subscriptions />} />
          <Route path="Reports" element={<Reports />} />
          <Route path="SupportTickets" element={<SupportTickets />} />
          <Route path="SupportHandling/:conversationID" element={<SupportHandling />} />
          <Route path="UserManagement" element={<UserManagement />} />
          <Route path="Registration" element={<Registration />} />
          <Route path="PatientList" element={<PatientList />} />
          <Route path="/Pharmacy" element={<ClinicPharmacy />} />
          <Route path="/AddPharmacy" element={<AddPharmacy />} />
         
          <Route path="/PharmacyView" element={<PharmacyView />} />
          <Route path="/Staff" element={<StaffMain />} />
          <Route path="/StaffAdd" element={<StaffStepper />} />
          <Route path="/StaffView" element={<StaffView />} />
          <Route path="/StaffAttendence" element={<StaffAttendence />} />
        </Route>
        
      <Route element={<ProtectedLayout />}>
       

        {/* Clinic Sidebar */}

        <Route element={<ClinicSidebar />}>
          <Route path="ClinicDashboard" element={<ClinicDashboard />} />
          <Route path="clinic/Registration" element={<Registration />} />
          <Route path="PatientOverview" element={<PatientOverview />} />
          <Route path="AddPatient" element={<AddPatient />} />
          <Route path="AddDoctor" element={<AddDoctor />} />
          <Route path="ClinicPatients" element={<ClinicPatients />} />
          <Route path="Departments" element={<Departments />} />
          <Route path="DepartmentDetails/:specialization/:displayName" element={<DepartmentDetails />} />
          <Route path="PatientReports" element={<PatientReports />} />
          <Route path="clinic/analytics" element={<ClinicAnalytics />} />
          <Route
  path="ViewReports/:patientUserUniqueID/:appointmentID"
  element={<ViewReports />}
/>
          <Route path="Doctors" element={<Doctors />} />
          <Route path="Clinicprescription" element={<ClinicPrescription />} />
          <Route path="Billing" element={<ClinicBilling />} />
          <Route path="CreateInvoice" element={<CreateInvoice />} />
          <Route
  path="CreateInvoice/:appointmentID/:patientUserUniqueID/:userClinicId"
  element={<CreateInvoice />}
/>
          <Route path="DoctorProfile/:id" element={<DoctorProfile />} />
          <Route path="Doctorstable" element={<DoctorsTable />} />
          <Route path="AddPatientReports" element={<AddPatientReports />} />
          <Route path="invoice" element={<Invoice />} />
          <Route path="clinic/appointments" element={<ClinicAppointments />} />
          <Route path="AddAppointment" element={<AddAppointment />} />
          <Route path="OTBookings" element={<OTBookings />} />
          <Route path="DoctorView" element={<DoctorView />} />
          <Route path="ClinicPatientView/:id" element={<ClinicPatientView />} />
          <Route path="ClinicUsers" element={<ClinicUsers />} />
          <Route path="ClinicRegistration" element={<ClinicRegistration />} />
          <Route path="DoctorsAdd/:id?" element={<DoctorsAdd />} />
          <Route path="PatientsAdd/:id?" element={<PatientsAdd />} />
          <Route path="AllAppointments" element={<AllAppointments />} />
          <Route path="OpCaseSheet" element={<OpCaseSheet />} />
          <Route path="ClinicProfile" element={<ClinicProfile />} />
          <Route path="ClinicPrescriptionView" element={<ClinicPrescriptionView />} />
          <Route 
  path="ClinicPrescriptionView/:userClinicID/:userUniqueID/:appointmentID" 
  element={<ClinicPrescriptionView />}
/>
          <Route path="PrescriptionDetails" element={<PrescriptionDetails />} />
          <Route path="OutPatientOverview" element={<OutPatientOverview />} />
          <Route path="DoctorInfoCard" element={<DoctorInfoCard />} />
          <Route path="AddDepartmentForm" element={<AddDepartmentForm />} />
          <Route
  path="ClinicsideAppointmentDetails/:appointmentId/:userClinicId"
  element={<ClinicsideAppointmentDetails />}
/>
          <Route path="InvoiceView/:invoiceNumber/:appointmentID" element={<InvoiceView />} />

        

          <Route path="EditPatientReport/:patientUserUniqueID/:appointmentID" element={<EditPatientReport />} />
          <Route path="BedAllotment" element={<BedAllotement />} />
          <Route path="PatientAdmission" element={<PatientAdmission />} />
          <Route path="MonitorTracking" element={<MonitorTracking />} />
          <Route path="WardPharmacy" element={<WardPharmacy />} />
          <Route path = "MonitorPatientDetails" element={<MonitorPatientDetails/>} />
          <Route path = "PatientCareDetailedView/:id" element={<PatientCareDetailedView/>} />
          <Route path="/CareTrackingScreen" element={<CareTrackingScreen />} />
          <Route path="/CareTrackingForm" element={<CareTrackingForm />} />
        </Route>

        {/* Doctor Sidebar */}

        <Route element={<DoctorSidebar />}>
          <Route path="DoctorDashBoard" element={<DoctorDashBoard />} />
          <Route
  path="DoctorPrescriptionDetails/:userUniqueID/:appointmentID"
  element={<DrPrescriptionDetails />}
/>
          <Route path="PatientRescheduled" element={<PatientRescheduled />} />
          <Route
            path="DoctorPrescriptionView"
            element={<DoctorPrescriptionView />}
          />
          <Route path="prescriptionform" element={<ClinicPrescriptionForm />} />
          <Route path="Appointments">
            <Route
              path="upcoming-appointments"
              element={<UpcomingAppointments />}
            />
            <Route
              path="appointments-history"
              element={<AppointmentHistory />}
            />
            <Route
              path="todays-appointments"
              element={<TodaysAppointments />}
            />
          </Route>
          <Route path="DoctorAppointments" element={<DoctorAppointments />} />
          <Route path="patient-history" element={<PatientHistory />} />
          <Route path="PatientDetails" element={<PatientDetails />} />
          <Route path="PatientRecord" element={<PatientRecord />} />
          <Route path="dr-patients">
          <Route path="list" element={<DrPatientsList />} />
          </Route>
          <Route path="Prescription" element={<Prescription />} />
          <Route path="LabReportsHistory" element={<LabReportsHistory />} />
          <Route path="TreatmentPlans" element={<TreatmentPlans />} />
          <Route path="DoctorPatientView" element={<DoctorPatientView />} />
          <Route path="AddPrescription" element={<AddPrescription />} />
          <Route 
  path="/AppointmentDetails/:appointmentId/:userClinicId" 
  element={<AppointmentDetails />} 
/>
          <Route path="DoctorsideProfile" element={<DoctorsideProfile />} />
          <Route
            path="RescheduleAppointment"
            element={<RescheduleAppointment />}
          />
          <Route path="PatientsOverview/:id" element={<PatientsOverview />} />
           <Route path="/DrPatientReports/:patientUserUniqueID/:appointmentID/:doctorUserUniqueID" element={<DrPatientReports />} />
            <Route path="LabReport" element={<LabReport />} />
        </Route>

        {/* patient Sidebar */}

        <Route element={<PatientSidebar />}>
          <Route path="PatientProfile" element={<PatientProfile />} />
          <Route path="PatientAppointments" element={<PatientAppointments />} />
          <Route path="PatientLabReports" element={<PatientLabReports />} />
          <Route
            path="ViewPatientLabReports"
            element={<ViewPatientLabReports />}
          />
          <Route path="PatientPrescription" element={<PatientPrescription />} />
          <Route path="Treatments" element={<Treatments />} />
        </Route>

        {/* Pharmacy */}

        <Route element={<PharmacySidebar />}>
          <Route path="DashboardOverview" element={<PharmaDashboard />} />
          <Route path="Medicine&Inventory" element={<MedicineInventory />} />
          <Route path="PrescriptionIntegration" element={<PrescriptionIntegration />} />
          <Route path="Billing&Sales" element={<PharmaBilling />} />
          <Route path="PharmacyBilling" element={<ProcurementSupplier />} />
          <Route path="AddBilling" element={<AddInvoiceForm />} />
           <Route path="AddPayement" element={<AddPaymentForm />} />
           <Route path="SalesReturn" element={<SalesReturn />} />   
          <Route path="Compliance&Security" element={<ComplianceSecurity />} />
          <Route path="Reports&Analytics" element={<ReportsAnalytics />} />
          <Route path="Multi-BranchPharmacy" element={<MultiBranchPharmacy />} />
          <Route path="/PharmacyMedicine" element={<PharmacyMedicine />} />
          <Route path="/AddPharmacyUser" element={<AddPharmacy />} />
            <Route path="/AddSettings" element={<AddSettings />} />
          <Route path="/PharmacyViewUser" element={<PharmacyView />} />
            <Route path="/Procurement" element={<Procurement/>} />  
             <Route path="/ProcurementTabs" element={<ProcurementTabs/>} />
            <Route path="/PharmacyintegrationDetails" element={<PharmacyintegrationDetails/>} />
          <Route path="/pharma/analytics" element={<PharmaAnalytics />} />
          <Route path="/AddBranchPharmacy" element={<AddBranchPharmacy />} />
          <Route path="/BranchView" element={<BranchView />} />
           <Route path="/CompSecuAddemp" element={<CompSecuAddemp />} />
             <Route path="/PharmacyDashboard" element={<PharmacyDashboard />} />
             <Route path="/PharmacyInvoice" element={<PharmacyInvoice />} />
               <Route path="/PharmacyCustomerorders" element={<PharmacyCustomerorders />} />
                <Route path="/OrderInvoice" element={<OrderInvoice />} />
               <Route path="/PharmacyOrderdashboard" element={<PharmacyOrderdashboard />} />
                <Route path="/PharmacyOrderDetails" element={<PharmacyOrderDetails />} />
                <Route path="/PharmacyBrandDetails" element={<PharmacyBrandDetails />} />
                <Route path="/PharmacyCategoryDetails/:categoryName" element={<PharmacyCategoryDetails />} />
               <Route path="/PharmacyPescription" element={<PharmacyPescription />} />
               <Route path="/PharmacyExpenses" element={<PharmacyExpenses />} />
               <Route path="/PatientFollowUp" element={<PatientFollowUp/>}/>
               <Route path="/PharmacyMultibranches" element={<PharmacyMultibranches />} />
               <Route path="/PharmacyDistribution" element={<PharmacyDistribution />} />
                <Route path="/PharmacyPurchase1" element={<PharmacyPurchase1 />} />
               <Route path="/sales/invoices" element={<PharmacySales />} />
               <Route path="/sales/returns" element={<SaleReturns />} />
               <Route path="/sales/add-return" element={<AddSaleReturn />} />
               <Route path="/PharmacyStock" element={<PharmacyStock />} />
                <Route path="/SupplierMaster" element={<SupplierMaster />} />
                <Route path="/PurchaseOrder" element={<PurchaseOrder />} />
             <Route path="/PurchaseOrder/:pharmaId/:purchaseId" element={<PurchaseOrder />} />
               <Route path="/PharmacyPurchasereturn" element={<PharmacyPurchasereturn />} />
               <Route path = "/add-distributor" element = {<AddDistributor/>}/>
              <Route path="/SelectDistrubutorModal" element={<SelectDistrubutorModal />} />
               <Route path="/PharmacyOrders" element={<PharmacyOrders />} />
               <Route path="/CartPage" element={<CartPage />} />
               <Route path="/PatientSaleHistory" element={<PatientSaleHistory />} />
               <Route path="/StockComponentScreen" element={<StockComponentScreen />} />
               
        </Route>
 </Route>
      </Route>
    </Route>
  )
);

export default routes;
